function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedBabyCribFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.5a1 1 0 00-2 0v24h2v-3h24v3h2v-24a1 1 0 10-2 0v4.17c-.313-.11-.65-.17-1-.17H5c-.35 0-.687.06-1 .17V4.5zm24 19v-2H4v2h24zm0-4v-8a1 1 0 00-1-1h-2v9h3zm-5 0v-9h-2v9h2zm-4 0h-2v-9h2v9zm-4 0v-9h-2v9h2zm-4 0H9v-9h2v9zm-4 0v-9H5a1 1 0 00-1 1v8h3z",
    fill: props.color
  }));
}

export default SvgIconBedBabyCribFilled;